var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.541992 9.00033C0.541992 4.32892 4.32892 0.541992 9.00033 0.541992C13.6717 0.541992 17.4587 4.32892 17.4587 9.00033C17.4587 13.6717 13.6717 17.4587 9.00033 17.4587C4.32892 17.4587 0.541992 13.6717 0.541992 9.00033ZM12.3868 7.89359C12.7669 7.63405 12.8646 7.11554 12.6051 6.73547C12.3456 6.35539 11.8271 6.25768 11.447 6.51721L11.3626 6.57485C9.99516 7.50859 8.81648 8.68725 7.88436 10.0482L6.67252 8.83763C6.34691 8.51237 5.81927 8.51265 5.49401 8.83826C5.16874 9.16387 5.16903 9.69151 5.49464 10.0168L7.44563 11.9657C7.62929 12.1492 7.88796 12.2365 8.14526 12.2021C8.40256 12.1676 8.62909 12.0152 8.75796 11.7898C9.6337 10.2585 10.8456 8.94601 12.3024 7.95123L12.3868 7.89359Z",
    fill: "#08875D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.d2aada6d6906a1df54aa57a1663fd64f.svg";
export { ForwardRef as ReactComponent };